import { CSSProperties } from 'react';

export const container: CSSProperties = {
  backgroundColor: '#fff',
  width: '100%',
};

export const body: CSSProperties = {
  height: 405,
  margin: 'auto',
  position: 'relative',
  width: 360,
};

export const image1: CSSProperties = {
  left: 41,
  position: 'absolute',
  top: 150,
  width: 288,
};

export const aImage1: CSSProperties = {
  left: 92,
  position: 'absolute',
  top: 110,
  width: 41,
};
